import { useEffect, useState } from "react";
import { authDiagnostic } from "../utils/authDiagnostics";

export default function LoginDiagnostics() {
  const [available, setAvailable] = useState(false);
  const [copied, setCopied] = useState(false);
  const [fallback, setFallback] = useState("");
  useEffect(() => {
    const show = () => setAvailable(true);
    window.addEventListener("login-diagnostic-available", show);
    return () => window.removeEventListener("login-diagnostic-available", show);
  }, []);
  if (!available) return null;
  const copy = async () => {
    const text = JSON.stringify(authDiagnostic(), null, 2);
    try { await navigator.clipboard.writeText(text); setCopied(true); }
    catch { setFallback(text); }
  };
  return <div className="w-full md:w-[50%] mt-4 text-xs text-[#717171]">
    <button type="button" className="underline underline-offset-4" onClick={copy}>
      {copied ? "Diagnostic details copied" : "Copy diagnostic details"}
    </button>
    {fallback && <textarea aria-label="Diagnostic details" className="w-full mt-2 h-32" readOnly value={fallback} onFocus={e => e.target.select()} />}
  </div>;
}
